import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { JenzButton } from '../jenz-button/jenz-button';

@Component({
  selector: 'jenz-confirmation-dialog',
  imports: [CommonModule, ConfirmDialogModule, JenzButton],
  templateUrl: './jenz-confirmation-dialog.html',
  styleUrl: './jenz-confirmation-dialog.scss',
})
export class JenzConfirmationDialog {}
